export default __webpack_public_path__ + "static/media/flag_grey.8e4e6eda.svg";